import ProductTemplateSimple from "../templates/product-template-simple";
import { Eatoncontactor } from '../data/products'
function ProductEatonContactor() {
    return (
        <>
            <ProductTemplateSimple data = {Eatoncontactor}/>
        </>
    )
}

export default ProductEatonContactor;